class StimeConfig {
  storageKey = 'MC_STIME_OFFSET'

  async setOffsetTime(stime) {
    try {
      if (stime) {
        // 获取服务器时间 - 确保stime是数字类型的时间戳
        const numericStime =
          typeof stime === 'string' ? parseInt(stime, 10) : stime
        const serverTime = new Date(numericStime).getTime()

        // 获取本地时间
        const localTime = new Date().getTime()
        // 计算时间偏移量（服务器时间 - 本地时间）
        const timeOffset = serverTime - localTime
        // 将时间偏移量存储到本地
        localStorage.setItem(this.storageKey, timeOffset)
      }
    } catch (e) {
      console.error('getConfigStime error:', e)
    }
    return null
  }

  /**
   * 获取本地存储的时间偏移量
   * @returns {number} 时间偏移量（毫秒）
   */
  getLocalTimeOffset() {
    try {
      const offset = localStorage.getItem(this.storageKey)
      // 确保返回的是数字类型，处理空值和字符串情况
      return offset ? parseInt(offset, 10) : 0
    } catch (e) {
      console.error('getLocalTimeOffset error:', e)
      return 0
    }
  }

  /**
   * 获取当前的服务器时间
   * @returns {number} 服务器时间戳（毫秒）
   */
  getCurrentServerTime() {
    try {
      const offset = this.getLocalTimeOffset() // 已经是数字类型
      const localTime = new Date().getTime()
      return localTime + offset
    } catch (e) {
      console.error('getCurrentServerTime error:', e)
      return new Date().getTime()
    }
  }
}

export const stimeConfig = new StimeConfig()
